module.exports = __webpack_public_path__ + "img/logo_unl_pt_pb_negativo_0.60834558.png";